import styled from 'styled-components';

export const WrapperImage = styled.div`
  background-color: ${({ theme }) => theme.color.background.neutral.weak};
  border-radius: ${({ theme }) => theme.border.radius.default};
  margin-bottom: ${({ theme }) => theme.spacing.km4};

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km6};
    padding-inline: ${({ theme }) => theme.spacing.km8};
    padding-block: 38px;
  }

  img,
  video {
    width: 100%;
    border-radius: ${({ theme }) => theme.border.radius.medium};
    box-shadow: 0px 4px 40px 0px #00000026;
  }
`;
